import classNames from 'classnames';
import styles from './FJDisplayPanel.module.less';
import PropTypes from 'prop-types';
const FJDisplayPanel = props => {
    const { style, children, active, className, upOrDown } = props;
    const classBtn = classNames(
        styles.content,
        className,
        active ? styles.active : null,
        upOrDown === 'up' && active ? styles.up : null,
        upOrDown === 'down' && active ? styles.down : null,
    );

    return (
        <div style={style} className={classBtn}>
            {children}
        </div>
    );
};

FJDisplayPanel.propTypes = {
    style: PropTypes.object,
    children: PropTypes.node,
    active: PropTypes.bool,
    className: PropTypes.string,
    upOrDown: PropTypes.string,
};
export default FJDisplayPanel;
